const WA_NUMBER = "525568977539";

export const waLink = (message) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

export const WA_MESSAGES = {
  general: "Hola, vengo del sitio web de Condominio EHÉCATL. Quiero más información sobre los departamentos.",
  visita: "Hola, quiero agendar una visita a Condominio EHÉCATL. ¿Qué horarios tienen disponibles?",
  prototipoA: "Hola, me interesa el Prototipo A de EHÉCATL (86.40 m², 2 recámaras). ¿Me pueden compartir precio y disponibilidad?",
  prototipoB: "Hola, me interesa el Prototipo B de EHÉCATL (101.09 m², con family room). ¿Me pueden compartir precio y disponibilidad?",
  cotizacion: "Hola, quiero una cotización personalizada de un departamento en EHÉCATL.",
};

export const CONTACT = {
  phone: "55 6897 7539",
  web: "condominioehecatl.com",
  instagram: "https://www.instagram.com/condominioehecatl",
  facebook: "https://www.facebook.com/CondominioEhecatl/",
  address: "Benito Juárez Sur 20, La Mora, San Cristóbal Centro, 55030 Ecatepec de Morelos, Méx.",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Benito+Ju%C3%A1rez+Sur+20%2C+San+Crist%C3%B3bal+Centro%2C+55030+Ecatepec+de+Morelos",
};

export const PROTOTYPES = {
  a: {
    id: "a",
    name: "Prototipo A",
    size: "86.40 m²",
    units: 14,
    plan: "/images/plan_a.webp",
    price: "$2,402,100",
    tagline: "El equilibrio perfecto entre amplitud y funcionalidad.",
    features: [
      "Recámara principal con baño privado y walking closet",
      "1  recámara secundaria",
      "Segundo baño completo",
      "Terraza privada",
      "Cocina equipada",
      "Cuarto de lavado",
      "1  cajón de estacionamiento",
    ],
  },
  b: {
    id: "b",
    name: "Prototipo B",
    size: "101.09 m²",
    units: 14,
    plan: "/images/plan_b.webp",
    price: "$2,749,920",
    tagline: "Espacio de sobra para crecer: Family Room convertible en 3ª recámara.",
    features: [
      "Recámara principal con baño privado y walking closet",
      "1  recámara secundaria",
      "Family Room con opción a 3ª recámara",
      "Segundo baño completo",
      "Terraza privada",
      "Cocina equipada",
      "Cuarto de lavado",
      "1  cajón de estacionamiento",
    ],
  },
};

export const GALLERY = [
  { src: "/images/fachada_dusk.webp", title: "Fachada al atardecer", tag: "Render", tall: true },
  { src: "/images/tour/sala_2.webp", title: "Sala · comedor", tag: "Interior", tall: false },
  { src: "/images/roof_real_2.webp", title: "Roof garden con pérgola", tag: "Amenidad", tall: true },
  { src: "/images/tour/cocina_2.webp", title: "Cocina equipada", tag: "Interior", tall: false },
  { src: "/images/recamara.webp", title: "Recámara principal", tag: "Interior", tall: true },
  { src: "/images/cubo.webp", title: "Cubo de luz central", tag: "Arquitectura", tall: false },
  { src: "/images/tour/balcon_1.webp", title: "Balcón privado", tag: "Interior", tall: true },
  { src: "/images/tour/bano_2.webp", title: "Baño completo", tag: "Interior", tall: true },
  { src: "/images/walking.webp", title: "Walking closet", tag: "Interior", tall: true },
];

export const AMENITIES = [
  { title: "Roof garden común", desc: "164.24 m² con asador techado, tarja y baños para tus reuniones.", img: "/images/roof_real_1.webp" },
  { title: "2 roof gardens privados", desc: "96.81 m² de terraza exclusiva para los departamentos de último nivel.", img: "/images/roof_new_a.webp" },
  { title: "Eco elevador", desc: "Acceso cómodo a los 7 niveles con tecnología de bajo consumo.", img: "/images/cubo.webp" },
  { title: "Estacionamiento", desc: "28 cajones, 3 de visitas y espacios a doble altura. Uno por departamento independiente.", img: "/images/estacionamiento.webp" },
  { title: "Estacionamiento de visitas", desc: "3 cajones exclusivos para tus invitados, junto al acceso principal.", img: "/images/tour/estacionamiento_1.webp" },
  { title: "Caseta de vigilancia", desc: "Acceso controlado y monitoreado para la tranquilidad de tu familia.", img: "/images/amenidad_caseta.webp" },
  { title: "Circuito cerrado de TV", desc: "Cámaras de seguridad en accesos, estacionamiento y áreas comunes.", img: "/images/amenidad_cctv.webp" },
];
